/**
 * Fixed ports for E2E tests — telemetry is skipped when running on these ports.
 * Ports must be below 32768 to avoid collisions with the Docker ephemeral range.
 *
 * This is a dependency-free leaf module: it deliberately imports nothing so it
 * can be consumed from a Playwright `playwright.config.ts` (loaded inside the
 * test-worker process) without dragging in the OpenTelemetry graph. Pulling
 * OTel into a worker loads a second copy of `expect`, which silently breaks
 * Playwright's async matchers (`.toBeVisible()` returns an un-awaited Promise).
 */
export const E2E_TEST_PORTS = {
  ECOSYSTEM_HUB: 4251,
  ECOSYSTEM_MANAGER: 5815,
  PARTNER_HUB: 6971,
};

export function isE2EEnvironment(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.location.hostname === 'localhost' &&
    Object.values(E2E_TEST_PORTS).includes(Number(window.location.port))
  );
}
